var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleTagManager = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 256 256"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8AB4F8",
  d: "m150.262 245.516-44.437-43.33 95.433-97.455 46.007 45.09z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M150.45 53.938 106.176 8.731 9.36 104.629c-12.48 12.48-12.48 32.713 0 45.207l95.36 95.986 45.09-42.182-72.654-76.407z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#8AB4F8",
  d: "m246.625 105.37-96-96c-12.494-12.494-32.756-12.494-45.25 0s-12.495 32.757 0 45.252l96 96c12.494 12.494 32.756 12.494 45.25 0s12.495-32.757 0-45.251"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 127.265,
  cy: 224.731,
  r: 31.273,
  fill: "#246FDB"
})));
export default SvgGoogleTagManager;